import React from "react";
import { MoreVertical } from "lucide-react";
import "../../components/DashboardModule/MyQuotations.css";
import { LuSearch } from "react-icons/lu";

const QuotationSeller = () => {
    return (
        <div className="quo-container font-poppins">
            <div className="quo-header">
                <h2 className="quo-title"></h2>
                <div className="quo-actions">
              
                </div>
            </div>

            <table className="quo-table">
                <thead>
                    <tr>
                        <th>Enquiry No.</th>
                        <th>Product Details</th>
                        <th>Qty</th>
                        <th>Date</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td><input type="checkbox" /> 00123</td>
                        <td>Fastgear 24 inch
                            15mm Steel Black
                            Wire Plumbing
                            Connection </td>
                        <td>
                            <ul>
                                <li>Qty (50 pc)</li>
                            </ul>
                        </td>
                        <td>10/08/2023</td>
                        <td>
                            <div style={{border: "1px solid #cacaca", padding: "8px 8px", display: "inline-block",borderRadius:"8px",color:"#898989"}}>
                                Insert Value
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>
            <div className="quo-bottom-actions ">
                <button className="quo-accept font-poppins">SEND</button>
                <button className="quo-add-comment font-poppins">REJECT</button>
            </div>

            <div className="quo-summary">
                <table className="quo-summary-table">
                    <thead>
                        <tr>
                            <th>Order Id</th>
                            <th>Product Details</th>
                            <th>Qty</th>
                            <th>RA</th>
                            <th>Value Added</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>00123</td>
                            <td>Fastgear 24 inch
                                15mm Steel Black
                                Wire Plumbing
                                Connection</td>
                            <td>
                                <ul>
                                    <li>Qty (50 pc)</li>
                                </ul>
                            </td>
                            <td>Scheduled on

                                10/08/2023</td>
                            <td>Rs6,00,000
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="quo-bottom-actions ">
                <button className="quo-accept font-poppins">SEND</button>
                <button className="quo-add-comment font-poppins">REJECT</button>
            </div>
        </div>
    );
};

export default QuotationSeller;